import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { SideBarListItem, useStyles } from "./sizebaroptions-styles";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import StarBorder from "@mui/icons-material/StarBorder";
import * as React from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export const SideBarOptions = () => {
  const [open, setOpen] = React.useState(true);

  const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
  };

  const iconStyles =  {
    color: "text.main",
  }

  return (
    <>
      <Box className={classes.outerContainer}>
        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
          }}
        >
          General
        </Typography>

        <Box className={classes.innerContainer} />
        <Divider />
        <Box my={1} />

        <SideBarListItem onClick={handleClick}>
          <ListItemIcon>
            <MailIcon  sx={iconStyles} />
          </ListItemIcon>
          <ListItemText primary="Inbox" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </SideBarListItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          {["Starred", "Send email", "Drafts"].map((text, index) => (
            <SideBarListItem sx={{ pl: 4 }} button key={text}>
              <ListItemIcon>
                {index % 2 === 0 ? (
                  <InboxIcon
                    sx={iconStyles}
                  />
                ) : (
                  <MailIcon
                    sx={iconStyles}
                  />
                )}
              </ListItemIcon>
              <ListItemText primary={text} />
            </SideBarListItem>
          ))}
        </Collapse>

        <List>
          {["Starred", "Send email", "Drafts"].map((text, index) => (
            <SideBarListItem button key={text}>
              <ListItemIcon
                sx={iconStyles}
              >
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </SideBarListItem>
          ))}
        </List>
      </Box>
    </>
  );
};
